import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/src/locale/de';
import en from 'vuetify/src/locale/en';
import defaultTheme from '@/plugins/themes/defaultTheme';
import EncryptionStorage from '@/misc/EncryptionStorage';
import { RootState } from '@/store/storeStateInterfaces';
import { VuetifyThemeVariant } from 'vuetify/types/services/theme';

Vue.use(Vuetify);
// if available load the customTheme here, to avoid a visible theme change from default to custom theme
// if a custom theme was saved already.
let customTheme;
const encryptedStore = EncryptionStorage.getInstance();
const localStorageState = encryptedStore.getItem() as RootState;

if (localStorageState?.application && localStorageState.application.customTheme) { // Only load the custom theme if available!
    customTheme = localStorageState.application.customTheme;
}

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: customTheme as Partial<VuetifyThemeVariant> || defaultTheme
        }
    },
    lang: {
        locales: { de, en },
        current: 'de'
    }
});
